
export const CONFIG = {
    PROGRAM: '5rpL8docrvGBImXXmYEy',
    UNIVERSITY_LEVEL: '0t8YU0G6upcarWr3JQPR',
    DEGREE: 'LWdEa5r6A8bv8WWz5XPy',
    FEE_PROGRAM: 'H5MkjZpy2BhsaasOOaC1',
    GPT: '3FvaZmN22NZON1cv3J0Z',
    IEP_PROGRAM: 'WBzTzZx5bzGlw0FZsEWv',
}

export const APPS = {
    SIZE: 30,
    DEBOUNCE_TIME: 300,
    PLACEMENT_TEST_DURATION: 3600,
}

export const COLLECTION_NAME = {
    TUTORS: 'tutors',
    BATCHES: 'training_batches',
    PROGRAM: 'resource_programs',
    LEVEL: 'resource_levels',
    LESSON: 'resource_lessons',
    GRAMMAR_IN_USE: 'grammar_in_use',
    MODULE: 'resource_modules',
    ACTIVITY: 'resource_activities',
    ACTIVITY_TYPE: 'resource_activity_types',
    SKILL: 'resource_skills',
    DIFFICULTY: 'resource_difficulty',
    BOOK_STORE_TRENDING: 'book_store_trending',
    BOOK_STORE_GENRES: 'book_store_genres',
    BOOK_STORE_SECTIONS: 'book_store_sections',
    BOOK_STORE_BOOKS: 'book_store_books',
    BOOK_STORE_AUTHOR: 'book_store_authors',
    GENERAL_PLACEMENT_TEST: 'general_placement_test',
    BOOK_STORE_PUBLISHER: 'book_store_publishers',
    BOOK_STORE_SLIDES: 'book_store_slides',
    VOCABULARY: 'vocabulary',
    GRAMMAR: 'grammar',
    LISTENING: 'listening',
    READING: 'reading',
    GENERAL_TESTING: 'general_testing',
    TUTOR: 'tutors',
    CLASSROOMS: 'classrooms',
    STUDENTS: 'students',
    //X-READING
    READING_LIBRARY: 'reading_library',
    READING_LEVEL: 'reading_level',
    READING_WORDS: 'reading_words',
    READING_ENGLISH_TYPE: 'reading_english_types',
    READING_FORMAT: 'reading_format',
    READING_TARGET_AGE: 'reading_target_age',
    READING_TYPE: 'reading_type',
    READING_BATCH_LEVEL: 'reading_batch_level',
    READING_BATCHES: 'reading_batches',

    //APP_CENTER
    APP_SLIDES: 'app_slides',
    APP_VIDEOS: 'app_videos',
    APP_SKILL: 'app_skills',
    APP_CATEGORY: 'app_categories',

    //APP_CENTER
    APP_NEW_AND_TRENDING: 'app_new_and_trending',
    APP_TOP_CHARTS: 'app_top_charts',
    APP_SPECIAL_OFFERS_AND_FREE: 'app_special_offers_and_free',
    APP_BOOKS_WE_LOVE: 'books_we_love',
    USERS: 'users',
}


export const PRICE_OPTIONS = [
    { key: 1, name: 'Sell' },
    { key: 2, name: 'Free' },
]

export const LANGUAGE_LIST = [
    { key: 0, name: 'American', code: 'US' },
    { key: 1, name: 'English', code: 'EN' },
    { key: 2, name: 'Khmer', code: 'KH' },
]

export const APP_OBJECTS = [
    { key: 1, name: 'Reading' },
    { key: 2, name: 'Language Training' },
]

export const FILE_FOLDER={
    TRAINING_RESOURCES:'training_resources'
}

export const ACADEMIC_YEAR_STATUS = [
  { key: 1, text: 'Hold' },
  { key: 2, text: 'Active' },
  { key: 3, text: 'Close' },
];

export const PROGRAM_OPTION_OBJ = {
  yearBase: { key: 1, text: 'Year Base' },
  termBase: { key: 2, text: 'Term Base' },
}

export const PROGRAM_TERMS_OBJ = {
  term1: { key: 1, text: 'Term 1' },
  term2: { key: 2, text: 'Term 2' },
  term3: { key: 3, text: 'Term 3' },
  term4: { key: 4, text: 'Term 4' },
}

export const YEAR_LIST = [
  { key: 2019, text: "2019-2020" },
  { key: 2020, text: "2020-2021" },
  { key: 2021, text: "2021-2022" },
  { key: 2022, text: "2022-2023" },
  { key: 2023, text: "2023-2024" },
  { key: 2024, text: "2024-2025" },
  { key: 2025, text: "2025-2026" },
  { key: 2026, text: "2026-2027" },
  { key: 2027, text: "2027-2028" },
  { key: 2028, text: "2028-2029" },
  { key: 2029, text: "2029-2030" },
  { key: 2030, text: "2030-2031" },
];

export const PROGRAM_OPTION = [
  { key: 1, text: 'Year Base' },
  { key: 2, text: 'Term Base' },
]
export const PROGRAM_TERMS = [
  { key: 1, text: 'Term 1' },
  { key: 2, text: 'Term 2' },
  { key: 3, text: 'Term 3' },
  { key: 4, text: 'Term 4' },
]

export const StatusObj = {
  DISABLED: { key: 0, text: "Disabled" },
  ACTIVE: { key: 1, text: "Active" },
};
